import { DOCUMENT_REGISTER_TYPE_PATH } from "@/modules/document-register/pages/document-register-type-page";
import { generatePath, Navigate } from "react-router-dom";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

/**
 * Открывает тип реестра на конкретном файле шаблона: `fileId` переезжает
 * в query-параметр страницы, где его читает виджет типа реестра.
 */
export function OpenDocumentRegisterTypeFile() {
  const url = new URL(window.location.href);
  const typeId = url.searchParams.get("id");
  const fileId = url.searchParams.get("fileId");

  if (!typeId) {
    return <ToPageNotFound />;
  }

  url.search = "";
  url.pathname = generatePath(DOCUMENT_REGISTER_TYPE_PATH, { typeId });

  if (fileId) {
    url.searchParams.set("fileId", fileId);
  }

  return <Navigate to={url.toString().replace(url.origin, "")} />;
}
